module.exports = __webpack_public_path__ + "static/media/menu_agenda.7cd1b0bf.png";